module.exports = __webpack_public_path__ + "static/media/logo-whatsapp.68c213fc.svg";